import React, { useEffect, useState, useCallback } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { PREVIEW_DOC_TYPES } from "../../../util/Constants";
import { Button, Col, Row, Space, Spin } from "antd";
//@ts-ignore
import pdfjsWorker from "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry";
import { RotateLeftOutlined, RotateRightOutlined, ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface PreviewProps {
    docURL?: string;
    divHeight?: string;
}

const PreviewModalComp: React.FC<PreviewProps> = ({ docURL, divHeight }) => {
    const [pageNumbers, setPageNumbers] = useState<number[]>([]);
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>();
    const [rotation, setRotation] = useState<number>(0);
    const [imageWidth, setImageWidth] = useState<number>(100);

    const onDocumentLoadSuccess = useCallback((pdf: pdfjs.PDFDocumentProxy) => {
        const numPages = pdf.numPages;
        const pages = Array.from({ length: numPages }, (_, i) => i + 1);
        setPageNumbers(pages);
    }, []);

    const checkDocumentContentType = useCallback((base64: string): PREVIEW_DOC_TYPES => {
        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }
    }, []);

    useEffect(() => {
        if (docURL) {
            setDocType(checkDocumentContentType(docURL));
        }
    }, [docURL, checkDocumentContentType]);

    const onRotateRight = useCallback(() => {
        setRotation((prevRotation) => (prevRotation + 90) % 360);
    }, []);

    const onRotateLeft = useCallback(() => {
        setRotation((prevRotation) => (prevRotation - 90 + 360) % 360);
    }, []);

    const imageZoomIn = useCallback(() => {
        setImageWidth((prevWidth) => prevWidth + 25);
    }, []);

    const imageZoomOut = useCallback(() => {
        setImageWidth((prevWidth) => (prevWidth > 25 ? prevWidth - 25 : prevWidth));
    }, []);

    return (
        <div>
            {docType === PREVIEW_DOC_TYPES.PDF && docURL ? (
                <Document
                    file={docURL}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    {pageNumbers.map(page => (
                        <div key={page} style={{ padding: '8px', backgroundColor: '#dadada' }}>
                            <Page
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                                pageNumber={page}
                            />
                        </div>
                    ))}
                </Document>
            ) : docType === PREVIEW_DOC_TYPES.IMAGE && docURL ? (
                <Row>
                    <Col
                        lg={24}
                        style={{
                            overflow: "auto",
                            height: divHeight,
                            padding: '16px',
                            textAlign: 'center'
                        }}
                        className='image-view-col-height'
                    >
                        <img
                            alt="example"
                            style={{ width: `${imageWidth}%`, transform: `rotate(${rotation}deg)` }}
                            src={docURL}
                        />
                    </Col>
                    <Col lg={24} className='margin_top_10' style={{ textAlign: 'center' }}>
                        <Space>
                            <Button onClick={onRotateLeft}><RotateLeftOutlined /></Button>
                            <Button onClick={imageZoomIn}><ZoomInOutlined /></Button>
                            <Button onClick={imageZoomOut}><ZoomOutOutlined /></Button>
                            <Button onClick={onRotateRight}><RotateRightOutlined /></Button>
                        </Space>
                    </Col>
                </Row>
            ) : (
                <div className="loader-container">
                    <Spin size="large" tip="Loading"></Spin>
                </div>
            )}
        </div>
    );
};

export default PreviewModalComp;
